import React, {ReactElement, ReactNode} from 'react';
import {Wrapper} from './style';

interface AdornedTextProps {
  children: ReactNode;
}

export const AdornedText = ({children}: AdornedTextProps): ReactElement => (
  <Wrapper>
    <span className='text'>{children}</span>&nbsp;
  </Wrapper>
);
